import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=0e59fa5b&"
import script from "./CatalogView.vue?vue&type=script&lang=ts&"
export * from "./CatalogView.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogView.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports